import React from 'react';
import { useLocale } from '@/i18n/LocaleProvider';

// Quotes stay in the speaker's approved English on every site (render them with lang="en", which the
// translation helpers leave alone). On gizmodata.com.br this adds our own Portuguese translation underneath,
// labelled as one (founder decision 2026-10-17). Renders nothing on the English site.
const QuoteGloss = ({ ptBR, className = '' }: { ptBR?: string; className?: string }) => {
  const { locale } = useLocale();
  if (locale !== 'pt-BR' || !ptBR) return null;
  return (
    <p lang="pt-BR" className={`mt-3 text-sm leading-relaxed opacity-80 ${className}`} data-quote-gloss>
      <span className="font-medium">Tradução livre:</span> &ldquo;{ptBR.replace(/^[“"]|[”"]$/g, '')}&rdquo;
    </p>
  );
};

export default QuoteGloss;
